import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [
	{ title: 'Product Liability Insurance' },
	{
		name: 'description',
		content: 'We offer insurance for product liability.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Product Liability Insurance</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Product liability insurance covers your liability for the completed
				operations of your business and/or the products that you manufacture or
				sell. It includes injuries or damage that occur after you have completed
				the job and left the site or relinquished control of a product that you
				manufactured or sold.
			</p>
		</main>
	)
}
